import { FormControlLabel, Grid, Typography } from '@material-ui/core';
import { ICourse, enStatus } from 'interface/course';
import { Link, useParams } from 'react-router-dom';
import { getLessonSaved, saveLesson } from 'services/savedLessons';
import { isStatusNegative, slugify } from 'utils';
import { useEffect, useState } from 'react';

import ChevronLeft from '@eduzz/houston-icons/ChevronLeft';
import ChevronRight from '@eduzz/houston-icons/ChevronRight';
import ContactChannels from 'components/Course/ContactChannels';
import { CourseTheme } from 'assets/themes/Course';
import { ILesson } from 'interface/lesson';
import SaveOutline from '@eduzz/houston-icons/SaveOutline';
import WatchedLesson from '../LessonActions/WatchedLesson';
import { clearLessonState } from 'redux/lesson/slice';
import { lessonParams } from 'interface/lessonParams';
import { makeStyles } from '@material-ui/core';
import { useAppSelector } from 'hooks/redux';
import { useDispatch } from 'react-redux';

interface IProps {
  next: ILesson['next'];
  prev: ILesson['previous'];
  isAuthenticated?: boolean;
  status: enStatus;
}
interface INavigationStylesProps {
  isLessonSaved: boolean;
}
interface INavigationStylesProps {
  isLessonSaved: boolean;
}

const useStyles = (props: INavigationStylesProps) =>
  makeStyles<CourseTheme>((theme) => ({
    bar: {
      background: theme.palette.grey[600],
    },
    link: {
      display: 'flex',
    },
    barContent: {
      maxWidth: 1260,
      padding: '0 20px',
      height: 72,
      width: '100%',
      margin: 'auto',
      [theme.breakpoints.down('md')]: {
        height: 'auto',
        padding: 0,
      },
    },
    barNavigationTextLeft: {
      marginRight: 20,
      marginLeft: 10,
    },
    barNavigationContainer: {
      display: 'flex',
      [theme.breakpoints.down('md')]: {
        justifyContent: 'center',
        borderBottom: '1px solid grey',
        padding: '20px 0',
      },
    },
    barNavigationTextRight: {
      paddingLeft: 20,
      marginRight: 10,
      borderLeft: '2px solid white',
    },
    barNavigationButtonContainer: {
      color: 'white',
      '& > p': {
        color: 'white',
        fontSize: 14,
        fontWeight: '700',
      },
    },
    saveLessonContainer: {
      display: 'flex',
      color: 'white',
      '& > span': {
        color: props.isLessonSaved ? theme.palette.primary.light : theme.palette.common.white,
        fontWeight: 600,
        fontSize: 14,
        marginLeft: 10,
      },
      [theme.breakpoints.down('md')]: {
        padding: '20px 0px 10px 20px',
      },
    },
    contactChannels: {
      [theme.breakpoints.down('md')]: {
        padding: '20px 0px 10px 20px',
      },
    },
  }));

const Navigation = (props: IProps) => {
  const [isLessonSaved, setIsLessonSaved] = useState<boolean>(false);
  const course = useAppSelector((state) => state.course as ICourse);
  const { lessonID } = useParams<lessonParams>();
  const dispatch = useDispatch();

  const classes = useStyles({
    isLessonSaved,
  })();

  const { next, prev, isAuthenticated } = props;
  const { hash } = course;
  const statusNegative = isStatusNegative(props.status);

  useEffect(() => {
    if (isAuthenticated) getLessonSaved(lessonID).then(setIsLessonSaved);
  }, [lessonID]);

  const handleSaveLesson = () => {
    setIsLessonSaved((prev) => !prev);
    saveLesson(lessonID);
  };

  return (
    <Grid className={classes.bar} container alignItems='center'>
      <Grid container className={classes.barContent} justifyContent='space-between' alignItems='center'>
        <Grid className={classes.barNavigationContainer} lg={'auto'} xs={12}>
          {prev && (
            <Link
              aria-label='Botão voltar para a aula anterior'
              onClick={() => dispatch(clearLessonState())}
              className={classes.link}
              to={`/curso/${hash}/${course.slug || slugify(course.title)}/aula/${prev && prev.lesson}`}
            >
              <Grid className={classes.barNavigationButtonContainer} alignItems='center' container>
                <ChevronLeft />
                <Typography className={classes.barNavigationTextLeft} id='lesson-previous-lesson'>
                  Aula anterior
                </Typography>
              </Grid>
            </Link>
          )}

          {next && (
            <Link
              aria-label='Botão avançar para a próxima aula'
              onClick={() => dispatch(clearLessonState())}
              className={classes.link}
              to={`/curso/${hash}/${course.slug || slugify(course.title)}/${
                next
                  ? `aula/${next && next.lesson}`
                  : !!course.progress && !!course.progress.certificate
                  ? `certificado`
                  : ''
              }`}
            >
              <Grid className={classes.barNavigationButtonContainer} alignItems='center' container>
                <Typography
                  style={!prev ? { borderLeft: 'none' } : null}
                  className={classes.barNavigationTextRight}
                  id='lesson-next-lesson'
                >
                  Próxima aula
                </Typography>
                <ChevronRight />
              </Grid>
            </Link>
          )}
        </Grid>
        {!statusNegative && isAuthenticated && (
          <>
            <Grid lg={'auto'} xs={12} id='lesson-save-lesson'>
              <FormControlLabel
                aria-label='Botão salvar aula'
                onClick={handleSaveLesson}
                className={classes.saveLessonContainer}
                control={<SaveOutline />}
                label='Salvar esta aula'
              />
            </Grid>
            {course.allow_manual_watch && (
              <Grid lg={'auto'} xs={12}>
                <WatchedLesson />
              </Grid>
            )}
            <Grid id='lesson-contact-channels' lg={'auto'} xs={12} className={classes.contactChannels}>
              <ContactChannels />
            </Grid>
          </>
        )}
      </Grid>
    </Grid>
  );
};

export default Navigation;
